import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5f2f1526 = () => interopDefault(import('../../../pages/404-error/index.vue' /* webpackChunkName: "pages/404-error/index" */))
const _04240c1b = () => interopDefault(import('../../../pages/app/index.vue' /* webpackChunkName: "pages/app/index" */))
const _223a12ea = () => interopDefault(import('../../../pages/builder-data-reports/index.vue' /* webpackChunkName: "pages/builder-data-reports/index" */))
const _500a6e81 = () => interopDefault(import('../../../pages/buy-sell-your-home/index.vue' /* webpackChunkName: "pages/buy-sell-your-home/index" */))
const _4e9535ac = () => interopDefault(import('../../../pages/buy-your-home/index.vue' /* webpackChunkName: "pages/buy-your-home/index" */))
const _2fb8881a = () => interopDefault(import('../../../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _9f28163a = () => interopDefault(import('../../../pages/commissions-calculator/index.vue' /* webpackChunkName: "pages/commissions-calculator/index" */))
const _91eee05a = () => interopDefault(import('../../../pages/comparables/index.vue' /* webpackChunkName: "pages/comparables/index" */))
const _5d8d5bda = () => interopDefault(import('../../../pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _63a1a260 = () => interopDefault(import('../../../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _6b59e2f4 = () => interopDefault(import('../../../pages/favourites/index.vue' /* webpackChunkName: "pages/favourites/index" */))
const _1638cb28 = () => interopDefault(import('../../../pages/list-home/index.vue' /* webpackChunkName: "pages/list-home/index" */))
const _0ed1cd48 = () => interopDefault(import('../../../pages/listing-management/index.vue' /* webpackChunkName: "pages/listing-management/index" */))
const _7404fba3 = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _076a15d6 = () => interopDefault(import('../../../pages/market-data/index.vue' /* webpackChunkName: "pages/market-data/index" */))
const _3c00d4a8 = () => interopDefault(import('../../../pages/messages/index.vue' /* webpackChunkName: "pages/messages/index" */))
const _e155355c = () => interopDefault(import('../../../pages/my-abode-overview/index.vue' /* webpackChunkName: "pages/my-abode-overview/index" */))
const _1fcfccac = () => interopDefault(import('../../../pages/my-listings/index.vue' /* webpackChunkName: "pages/my-listings/index" */))
const _e56f69d4 = () => interopDefault(import('../../../pages/offer-management-buyer/index.vue' /* webpackChunkName: "pages/offer-management-buyer/index" */))
const _cd59825c = () => interopDefault(import('../../../pages/offer-management-seller/index.vue' /* webpackChunkName: "pages/offer-management-seller/index" */))
const _17a73f73 = () => interopDefault(import('../../../pages/offers/index.vue' /* webpackChunkName: "pages/offers/index" */))
const _05cd3942 = () => interopDefault(import('../../../pages/privacy/index.vue' /* webpackChunkName: "pages/privacy/index" */))
const _0cacd1f4 = () => interopDefault(import('../../../pages/pro-edit/index.vue' /* webpackChunkName: "pages/pro-edit/index" */))
const _3047ca25 = () => interopDefault(import('../../../pages/pro-marketplace/index.vue' /* webpackChunkName: "pages/pro-marketplace/index" */))
const _c28be638 = () => interopDefault(import('../../../pages/pro-search/index.vue' /* webpackChunkName: "pages/pro-search/index" */))
const _a26c040e = () => interopDefault(import('../../../pages/request-sticker/index.vue' /* webpackChunkName: "pages/request-sticker/index" */))
const _1e295244 = () => interopDefault(import('../../../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _690c499a = () => interopDefault(import('../../../pages/sell-your-home/index.vue' /* webpackChunkName: "pages/sell-your-home/index" */))
const _4860d1b4 = () => interopDefault(import('../../../pages/signup/index.vue' /* webpackChunkName: "pages/signup/index" */))
const _53310d3d = () => interopDefault(import('../../../pages/sold-data/index.vue' /* webpackChunkName: "pages/sold-data/index" */))
const _d27d303e = () => interopDefault(import('../../../pages/terms-of-service/index.vue' /* webpackChunkName: "pages/terms-of-service/index" */))
const _74e31f82 = () => interopDefault(import('../../../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _267fd7b8 = () => interopDefault(import('../../../pages/whoweare/index.vue' /* webpackChunkName: "pages/whoweare/index" */))
const _864009e2 = () => interopDefault(import('../../../pages/why-bode/index.vue' /* webpackChunkName: "pages/why-bode/index" */))
const _3ca30444 = () => interopDefault(import('../../../pages/admin/builder-report-management/index.vue' /* webpackChunkName: "pages/admin/builder-report-management/index" */))
const _fa425ec2 = () => interopDefault(import('../../../pages/admin/conversation/index.vue' /* webpackChunkName: "pages/admin/conversation/index" */))
const _35f05aa0 = () => interopDefault(import('../../../pages/admin/offer-management/index.vue' /* webpackChunkName: "pages/admin/offer-management/index" */))
const _5c61b42a = () => interopDefault(import('../../../pages/admin/showings/index.vue' /* webpackChunkName: "pages/admin/showings/index" */))
const _af648b22 = () => interopDefault(import('../../../pages/listings/review.vue' /* webpackChunkName: "pages/listings/review" */))
const _483ff449 = () => interopDefault(import('../../../pages/login/idp/index.vue' /* webpackChunkName: "pages/login/idp/index" */))
const _84f38fba = () => interopDefault(import('../../../pages/login/reset/index.vue' /* webpackChunkName: "pages/login/reset/index" */))
const _7e2f78c0 = () => interopDefault(import('../../../pages/offers/submit-success/index.vue' /* webpackChunkName: "pages/offers/submit-success/index" */))
const _5ccbbb4a = () => interopDefault(import('../../../pages/offers/summary/index.vue' /* webpackChunkName: "pages/offers/summary/index" */))
const _15d64a20 = () => interopDefault(import('../../../pages/pro-edit/profile/index.vue' /* webpackChunkName: "pages/pro-edit/profile/index" */))
const _799ba82c = () => interopDefault(import('../../../pages/pro-edit/service/index.vue' /* webpackChunkName: "pages/pro-edit/service/index" */))
const _368b166c = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/index" */))
const _414e9a1f = () => interopDefault(import('../../../pages/pro-marketplace/pro-login/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-login/index" */))
const _0e3ffde8 = () => interopDefault(import('../../../pages/pro-marketplace/pro-portal/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-portal/index" */))
const _9f25b0e6 = () => interopDefault(import('../../../pages/pro-marketplace/service-request/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/index" */))
const _6969019c = () => interopDefault(import('../../../pages/pro-marketplace/service-requests/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-requests/index" */))
const _c2e930dc = () => interopDefault(import('../../../pages/search/saved-search-list/index.vue' /* webpackChunkName: "pages/search/saved-search-list/index" */))
const _27b1b197 = () => interopDefault(import('../../../pages/signup/additional-information/index.vue' /* webpackChunkName: "pages/signup/additional-information/index" */))
const _7955b9b6 = () => interopDefault(import('../../../pages/signup/confirm/index.vue' /* webpackChunkName: "pages/signup/confirm/index" */))
const _458b2082 = () => interopDefault(import('../../../pages/admin/listings/import/index.vue' /* webpackChunkName: "pages/admin/listings/import/index" */))
const _321017e3 = () => interopDefault(import('../../../pages/admin/listings/update/index.vue' /* webpackChunkName: "pages/admin/listings/update/index" */))
const _4d561e18 = () => interopDefault(import('../../../pages/ds/callback/listing/index.vue' /* webpackChunkName: "pages/ds/callback/listing/index" */))
const _15a917e8 = () => interopDefault(import('../../../pages/ds/callback/offer/index.vue' /* webpackChunkName: "pages/ds/callback/offer/index" */))
const _eb821830 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index" */))
const _e940ce02 = () => interopDefault(import('../../../pages/pro-marketplace/service-request/photography-measurements/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/photography-measurements/index" */))
const _7dbb5d06 = () => interopDefault(import('../../../pages/admin/listings/update/form/index.vue' /* webpackChunkName: "pages/admin/listings/update/form/index" */))
const _7d471fbc = () => interopDefault(import('../../../pages/admin/listings/update/table/index.vue' /* webpackChunkName: "pages/admin/listings/update/table/index" */))
const _1c12e612 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index" */))
const _60e0d589 = () => interopDefault(import('../../../pages/admin/listings/update/form/constants/index.js' /* webpackChunkName: "pages/admin/listings/update/form/constants/index" */))
const _089c2dba = () => interopDefault(import('../../../pages/admin/listings/update/form/controls/index.js' /* webpackChunkName: "pages/admin/listings/update/form/controls/index" */))
const _d23e388a = () => interopDefault(import('../../../pages/admin/listings/update/form/listing-item/index.vue' /* webpackChunkName: "pages/admin/listings/update/form/listing-item/index" */))
const _7aa4c826 = () => interopDefault(import('../../../pages/admin/listings/update/services/AdminUpdateListingTableMapService.js' /* webpackChunkName: "pages/admin/listings/update/services/AdminUpdateListingTableMapService" */))
const _480bc37c = () => interopDefault(import('../../../pages/admin/listings/update/table/checkbox-cell.vue' /* webpackChunkName: "pages/admin/listings/update/table/checkbox-cell" */))
const _6464fc26 = () => interopDefault(import('../../../pages/admin/listings/update/table/constants/index.js' /* webpackChunkName: "pages/admin/listings/update/table/constants/index" */))
const _64d671ec = () => interopDefault(import('../../../pages/admin/listings/update/table/enums/index.js' /* webpackChunkName: "pages/admin/listings/update/table/enums/index" */))
const _93b02026 = () => interopDefault(import('../../../pages/admin/listings/update/table/header.vue' /* webpackChunkName: "pages/admin/listings/update/table/header" */))
const _3acafb9c = () => interopDefault(import('../../../pages/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps.js' /* webpackChunkName: "pages/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps" */))
const _07f65cac = () => interopDefault(import('../../../pages/pro-marketplace/profile/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/profile/_id/index" */))
const _36a47d52 = () => interopDefault(import('../../../pages/pro-marketplace/view-request/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/view-request/_id/index" */))
const _1db0c536 = () => interopDefault(import('../../../pages/buyer-checklist/_page/index.vue' /* webpackChunkName: "pages/buyer-checklist/_page/index" */))
const _4885dd78 = () => interopDefault(import('../../../pages/how-it-works/_id/index.vue' /* webpackChunkName: "pages/how-it-works/_id/index" */))
const _f7ef5098 = () => interopDefault(import('../../../pages/listing-editing/_id/index.vue' /* webpackChunkName: "pages/listing-editing/_id/index" */))
const _05209114 = () => interopDefault(import('../../../pages/listings/_id/index.vue' /* webpackChunkName: "pages/listings/_id/index" */))
const _d26015dc = () => interopDefault(import('../../../pages/pro/_id/index.vue' /* webpackChunkName: "pages/pro/_id/index" */))
const _df0a395a = () => interopDefault(import('../../../pages/seller-checklist/_page/index.vue' /* webpackChunkName: "pages/seller-checklist/_page/index" */))
const _4a728ee8 = () => interopDefault(import('../../../pages/settings/_section/index.vue' /* webpackChunkName: "pages/settings/_section/index" */))
const _38e766da = () => interopDefault(import('../../../pages/sold-property/_id/index.vue' /* webpackChunkName: "pages/sold-property/_id/index" */))
const _2409f75c = () => interopDefault(import('../../../pages/user/_id/index.vue' /* webpackChunkName: "pages/user/_id/index" */))
const _21df4942 = () => interopDefault(import('../../../pages/listings/_id/audit/index.vue' /* webpackChunkName: "pages/listings/_id/audit/index" */))
const _7059428a = () => interopDefault(import('../../../pages/listings/_id/dashboard/index.vue' /* webpackChunkName: "pages/listings/_id/dashboard/index" */))
const _541d9a5d = () => interopDefault(import('../../../pages/listings/_id/submit-success/index.vue' /* webpackChunkName: "pages/listings/_id/submit-success/index" */))
const _cf8d9e40 = () => interopDefault(import('../../../pages/settings/_section/enums/index.js' /* webpackChunkName: "pages/settings/_section/enums/index" */))
const _a4aeba98 = () => interopDefault(import('../../../pages/listings/_id/dashboard/enums.js' /* webpackChunkName: "pages/listings/_id/dashboard/enums" */))
const _310eab62 = () => interopDefault(import('../../../pages/listings/_id/viewings/_type/index.vue' /* webpackChunkName: "pages/listings/_id/viewings/_type/index" */))
const _6ec33cc4 = () => interopDefault(import('../../../pages/users/_id/_section/index.vue' /* webpackChunkName: "pages/users/_id/_section/index" */))
const _72d72a09 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404-error",
    component: _5f2f1526,
    name: "404-error"
  }, {
    path: "/app",
    component: _04240c1b,
    name: "app"
  }, {
    path: "/builder-data-reports",
    component: _223a12ea,
    name: "builder-data-reports"
  }, {
    path: "/buy-sell-your-home",
    component: _500a6e81,
    name: "buy-sell-your-home"
  }, {
    path: "/buy-your-home",
    component: _4e9535ac,
    name: "buy-your-home"
  }, {
    path: "/calendar",
    component: _2fb8881a,
    name: "calendar"
  }, {
    path: "/commissions-calculator",
    component: _9f28163a,
    name: "commissions-calculator"
  }, {
    path: "/comparables",
    component: _91eee05a,
    name: "comparables"
  }, {
    path: "/contact",
    component: _5d8d5bda,
    name: "contact"
  }, {
    path: "/faq",
    component: _63a1a260,
    name: "faq"
  }, {
    path: "/favourites",
    component: _6b59e2f4,
    name: "favourites"
  }, {
    path: "/list-home",
    component: _1638cb28,
    name: "list-home"
  }, {
    path: "/listing-management",
    component: _0ed1cd48,
    name: "listing-management"
  }, {
    path: "/login",
    component: _7404fba3,
    name: "login"
  }, {
    path: "/market-data",
    component: _076a15d6,
    name: "market-data"
  }, {
    path: "/messages",
    component: _3c00d4a8,
    name: "messages"
  }, {
    path: "/my-abode-overview",
    component: _e155355c,
    name: "my-abode-overview"
  }, {
    path: "/my-listings",
    component: _1fcfccac,
    name: "my-listings"
  }, {
    path: "/offer-management-buyer",
    component: _e56f69d4,
    name: "offer-management-buyer"
  }, {
    path: "/offer-management-seller",
    component: _cd59825c,
    name: "offer-management-seller"
  }, {
    path: "/offers",
    component: _17a73f73,
    name: "offers"
  }, {
    path: "/privacy",
    component: _05cd3942,
    name: "privacy"
  }, {
    path: "/pro-edit",
    component: _0cacd1f4,
    name: "pro-edit"
  }, {
    path: "/pro-marketplace",
    component: _3047ca25,
    name: "pro-marketplace"
  }, {
    path: "/pro-search",
    component: _c28be638,
    name: "pro-search"
  }, {
    path: "/request-sticker",
    component: _a26c040e,
    name: "request-sticker"
  }, {
    path: "/search",
    component: _1e295244,
    name: "search"
  }, {
    path: "/sell-your-home",
    component: _690c499a,
    name: "sell-your-home"
  }, {
    path: "/signup",
    component: _4860d1b4,
    name: "signup"
  }, {
    path: "/sold-data",
    component: _53310d3d,
    name: "sold-data"
  }, {
    path: "/terms-of-service",
    component: _d27d303e,
    name: "terms-of-service"
  }, {
    path: "/users",
    component: _74e31f82,
    name: "users"
  }, {
    path: "/whoweare",
    component: _267fd7b8,
    name: "whoweare"
  }, {
    path: "/why-bode",
    component: _864009e2,
    name: "why-bode"
  }, {
    path: "/admin/builder-report-management",
    component: _3ca30444,
    name: "admin-builder-report-management"
  }, {
    path: "/admin/conversation",
    component: _fa425ec2,
    name: "admin-conversation"
  }, {
    path: "/admin/offer-management",
    component: _35f05aa0,
    name: "admin-offer-management"
  }, {
    path: "/admin/showings",
    component: _5c61b42a,
    name: "admin-showings"
  }, {
    path: "/listings/review",
    component: _af648b22,
    name: "listings-review"
  }, {
    path: "/login/idp",
    component: _483ff449,
    name: "login-idp"
  }, {
    path: "/login/reset",
    component: _84f38fba,
    name: "login-reset"
  }, {
    path: "/offers/submit-success",
    component: _7e2f78c0,
    name: "offers-submit-success"
  }, {
    path: "/offers/summary",
    component: _5ccbbb4a,
    name: "offers-summary"
  }, {
    path: "/pro-edit/profile",
    component: _15d64a20,
    name: "pro-edit-profile"
  }, {
    path: "/pro-edit/service",
    component: _799ba82c,
    name: "pro-edit-service"
  }, {
    path: "/pro-marketplace/marketplace-for-pros",
    component: _368b166c,
    name: "pro-marketplace-marketplace-for-pros"
  }, {
    path: "/pro-marketplace/pro-login",
    component: _414e9a1f,
    name: "pro-marketplace-pro-login"
  }, {
    path: "/pro-marketplace/pro-portal",
    component: _0e3ffde8,
    name: "pro-marketplace-pro-portal"
  }, {
    path: "/pro-marketplace/service-request",
    component: _9f25b0e6,
    name: "pro-marketplace-service-request"
  }, {
    path: "/pro-marketplace/service-requests",
    component: _6969019c,
    name: "pro-marketplace-service-requests"
  }, {
    path: "/search/saved-search-list",
    component: _c2e930dc,
    name: "search-saved-search-list"
  }, {
    path: "/signup/additional-information",
    component: _27b1b197,
    name: "signup-additional-information"
  }, {
    path: "/signup/confirm",
    component: _7955b9b6,
    name: "signup-confirm"
  }, {
    path: "/admin/listings/import",
    component: _458b2082,
    name: "admin-listings-import"
  }, {
    path: "/admin/listings/update",
    component: _321017e3,
    name: "admin-listings-update"
  }, {
    path: "/ds/callback/listing",
    component: _4d561e18,
    name: "ds-callback-listing"
  }, {
    path: "/ds/callback/offer",
    component: _15a917e8,
    name: "ds-callback-offer"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up",
    component: _eb821830,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up"
  }, {
    path: "/pro-marketplace/service-request/photography-measurements",
    component: _e940ce02,
    name: "pro-marketplace-service-request-photography-measurements"
  }, {
    path: "/admin/listings/update/form",
    component: _7dbb5d06,
    name: "admin-listings-update-form"
  }, {
    path: "/admin/listings/update/table",
    component: _7d471fbc,
    name: "admin-listings-update-table"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up/successful",
    component: _1c12e612,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up-successful"
  }, {
    path: "/admin/listings/update/form/constants",
    component: _60e0d589,
    name: "admin-listings-update-form-constants"
  }, {
    path: "/admin/listings/update/form/controls",
    component: _089c2dba,
    name: "admin-listings-update-form-controls"
  }, {
    path: "/admin/listings/update/form/listing-item",
    component: _d23e388a,
    name: "admin-listings-update-form-listing-item"
  }, {
    path: "/admin/listings/update/services/AdminUpdateListingTableMapService",
    component: _7aa4c826,
    name: "admin-listings-update-services-AdminUpdateListingTableMapService"
  }, {
    path: "/admin/listings/update/table/checkbox-cell",
    component: _480bc37c,
    name: "admin-listings-update-table-checkbox-cell"
  }, {
    path: "/admin/listings/update/table/constants",
    component: _6464fc26,
    name: "admin-listings-update-table-constants"
  }, {
    path: "/admin/listings/update/table/enums",
    component: _64d671ec,
    name: "admin-listings-update-table-enums"
  }, {
    path: "/admin/listings/update/table/header",
    component: _93b02026,
    name: "admin-listings-update-table-header"
  }, {
    path: "/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps",
    component: _3acafb9c,
    name: "admin-listings-update-table-mixins-AdminListingsUpdateTableRowsProps"
  }, {
    path: "/pro-marketplace/profile/:id",
    component: _07f65cac,
    name: "pro-marketplace-profile-id"
  }, {
    path: "/pro-marketplace/view-request/:id",
    component: _36a47d52,
    name: "pro-marketplace-view-request-id"
  }, {
    path: "/buyer-checklist/:page",
    component: _1db0c536,
    name: "buyer-checklist-page"
  }, {
    path: "/how-it-works/:id",
    component: _4885dd78,
    name: "how-it-works-id"
  }, {
    path: "/listing-editing/:id",
    component: _f7ef5098,
    name: "listing-editing-id"
  }, {
    path: "/listings/:id",
    component: _05209114,
    name: "listings-id"
  }, {
    path: "/pro/:id",
    component: _d26015dc,
    name: "pro-id"
  }, {
    path: "/seller-checklist/:page",
    component: _df0a395a,
    name: "seller-checklist-page"
  }, {
    path: "/settings/:section",
    component: _4a728ee8,
    name: "settings-section"
  }, {
    path: "/sold-property/:id",
    component: _38e766da,
    name: "sold-property-id"
  }, {
    path: "/user/:id",
    component: _2409f75c,
    name: "user-id"
  }, {
    path: "/listings/:id?/audit",
    component: _21df4942,
    name: "listings-id-audit"
  }, {
    path: "/listings/:id?/dashboard",
    component: _7059428a,
    name: "listings-id-dashboard"
  }, {
    path: "/listings/:id?/submit-success",
    component: _541d9a5d,
    name: "listings-id-submit-success"
  }, {
    path: "/settings/:section?/enums",
    component: _cf8d9e40,
    name: "settings-section-enums"
  }, {
    path: "/listings/:id?/dashboard/enums",
    component: _a4aeba98,
    name: "listings-id-dashboard-enums"
  }, {
    path: "/listings/:id?/viewings/:type",
    component: _310eab62,
    name: "listings-id-viewings-type"
  }, {
    path: "/users/:id/:section",
    component: _6ec33cc4,
    name: "users-id-section"
  }, {
    path: "/",
    component: _72d72a09,
    name: "index"
  }, {
    path: "/buyer-checklist",
    redirect: "/buyer-checklist/getting-ready",
    name: "/buyer-checklist"
  }, {
    path: "/how-it-works",
    redirect: "/how-it-works/seller",
    name: "/how-it-works"
  }, {
    path: "/howitworks",
    redirect: "/how-it-works/seller",
    name: "/howitworks"
  }, {
    path: "/listings",
    redirect: "/search",
    name: "/listings"
  }, {
    path: "/listings/:city/:community/:propertyType/:price/:id",
    redirect: "/listings/:id",
    name: "/listings/:city/:community/:propertyType/:price/:id"
  }, {
    path: "/logout",
    redirect: "/",
    name: "/logout"
  }, {
    path: "/error404",
    redirect: "/404-error",
    name: "/error404"
  }, {
    path: "/pro-:id-:companyname",
    redirect: "/pro/:id",
    name: "/pro-:id-:companyname"
  }, {
    path: "/profiles/:id",
    redirect: "/users/:id",
    name: "/profiles/:id"
  }, {
    path: "/seller-checklist",
    redirect: "/seller-checklist/getting-ready",
    name: "/seller-checklist"
  }, {
    path: "/start-listing",
    redirect: "/sell-your-home",
    name: "/start-listing"
  }, {
    path: "/terms",
    redirect: "/terms-of-service",
    name: "/terms"
  }, {
    path: "/whybode",
    redirect: "/why-bode",
    name: "/whybode"
  }, {
    path: "/who-we-are",
    redirect: "/whoweare",
    name: "/who-we-are"
  }, {
    path: "/offers/seller",
    redirect: "/offer-management-seller",
    name: "/offers/seller"
  }, {
    path: "/offers/buyer",
    redirect: "/offer-management-buyer",
    name: "/offers/buyer"
  }, {
    path: "/documents",
    redirect: "/offer-management-seller",
    name: "/documents"
  }, {
    path: "/list-your-home",
    redirect: "/list-home",
    name: "/list-your-home"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
